// @TODO: move API key to the env file
export const MARKER_ICON =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAyOCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjU2NjY1IDE0LjIwNTRDMC41NjY2NSA2LjU2MjU3IDYuNTgxMDMgMC4zNjY2NjkgMTQgMC4zNjY2NjlDMjEuNDE4OSAwLjM2NjY2OSAyNy40MzMzIDYuNTYyNTcgMjcuNDMzMyAxNC4yMDU0QzI3LjQzMzMgMjAuNTU5NyAxOC4xNDc0IDM0LjU1NDIgMTUuMDE2NSAzOS4wOTJDMTQuNzY3OSAzOS40NTMxIDE0LjM4MzYgMzkuNjMzMyAxNCAzOS42MzMzQzEzLjYxNjQgMzkuNjMzMyAxMy4yMzIxIDM5LjQ1MzEgMTIuOTgzNCAzOS4wOTJDOS44NTI1MiAzNC41NTQyIDAuNTY2NjUgMjAuNTU5NyAwLjU2NjY1IDE0LjIwNTRaTTcuNzE2MjcgMTQuMjA1N0M3LjcxNjI3IDEwLjYzMDIgMTAuNTI5OCA3LjczMjQxIDEzLjk5OTkgNy43MzI0MUMxNy40NzAxIDcuNzMyNDEgMjAuMjgzNiAxMC42MzAyIDIwLjI4MzYgMTQuMjA1N0MyMC4yODM2IDE3Ljc4MDYgMTcuNDcwMSAyMC42Nzg0IDEzLjk5OTkgMjAuNjc4NEMxMC41Mjk4IDIwLjY3ODQgNy43MTYyNyAxNy43ODA2IDcuNzE2MjcgMTQuMjA1N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=';
export const USER_MARKER =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi43OTk4IDMuNDc2ODhDMTYuODg4OSAzLjg1NTg0IDIwLjE0NCA3LjExMDkxIDIwLjUyMyAxMS4ySDIzLjE5OThWMTIuOEgyMC41MjNDMjAuMTQ0IDE2Ljg4OTEgMTYuODg4OSAyMC4xNDQxIDEyLjc5OTggMjAuNTIzMVYyMy4ySDExLjE5OThWMjAuNTIzMUM3LjExMDc2IDIwLjE0NDEgMy44NTU3MiAxNi44ODkgMy40NzY3MyAxMi44SDAuNzk5ODA1VjExLjJIMy40NzY3M0MzLjg1NTcyIDcuMTEwOTQgNy4xMTA3NiAzLjg1NTg5IDExLjE5OTggMy40NzY4OFYwLjc5OTk4OEgxMi43OTk4VjMuNDc2ODhaTTExLjk5OTkgMTkuNDRDMTYuMTA4OSAxOS40NCAxOS40Mzk5IDE2LjEwOSAxOS40Mzk5IDEyQzE5LjQzOTkgNy44OTA5OSAxNi4xMDg5IDQuNTU5OTkgMTEuOTk5OSA0LjU1OTk5QzcuODkwODcgNC41NTk5OSA0LjU1OTg2IDcuODkwOTkgNC41NTk4NiAxMkM0LjU1OTg2IDE2LjEwOSA3Ljg5MDg3IDE5LjQ0IDExLjk5OTkgMTkuNDRaTTEyLjc5OTggMTJDMTIuNzk5OCAxMi40NDE4IDEyLjQ0MTYgMTIuOCAxMS45OTk4IDEyLjhDMTEuNTU4IDEyLjggMTEuMTk5OCAxMi40NDE4IDExLjE5OTggMTJDMTEuMTk5OCAxMS41NTgyIDExLjU1OCAxMS4yIDExLjk5OTggMTEuMkMxMi40NDE2IDExLjIgMTIuNzk5OCAxMS41NTgyIDEyLjc5OTggMTJaTTE0LjM5OTggMTJDMTQuMzk5OCAxMy4zMjU1IDEzLjMyNTMgMTQuNCAxMS45OTk4IDE0LjRDMTAuNjc0MyAxNC40IDkuNTk5OCAxMy4zMjU1IDkuNTk5OCAxMkM5LjU5OTggMTAuNjc0NSAxMC42NzQzIDkuNTk5OTkgMTEuOTk5OCA5LjU5OTk5QzEzLjMyNTMgOS41OTk5OSAxNC4zOTk4IDEwLjY3NDUgMTQuMzk5OCAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=';

export interface MapStyle {
  featureType?: string;
  elementType?: string;
  stylers?: { [key: string]: string | number }[];
}

export const mapStyles: MapStyle[] = [
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#d3d3d3',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        color: '#808080',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#b3b3b3',
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        weight: 1.8,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#d7d7d7',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#dadada',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        color: '#a7a7a7',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#d6d6d6',
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#efefef',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#696969',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        weight: 3
      },
      {
        visibility: 'on'
      }
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#737373',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

export const MAP_SETTINGS = {
  DEFAULT_MAP_OPTIONS: {
    scrollwheel: false,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
  },
  DEFAULT_CENTER: { lat: 57, lng: 20 },
  DEFAULT_ZOOM: 11,
  MARKER_SIZE: 50,
  MARKER_USER_SIZE: 32,
  PIXEL_OFFSET: {
    MARKER: {
      X: 0,
      Y: -62,
    },
  },
  DIRECTIONS_OPTIONS: { suppressMarkers: true, preserveViewport: true },
};
